import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Why BetterCode?',
    href: '#deliver'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: "Who It's For",
    href: '#who-for'
  }, {
    name: 'Case Studies',
    href: '#cases'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-md py-2' : 'shadow-sm py-3'}`} data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="flex justify-between items-center" data-id="element-186">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-187">
            <a href="#" aria-label="BetterCode AI home" data-id="element-188">
              <Logo className="h-14 w-[230px] sm:h-16 sm:w-[260px]" data-id="element-189" />
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-190">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-700 hover:text-brand-green transition-colors" data-id="element-191">
                {link.name}
              </a>)}
            <a href="#contact" className="px-5 py-2.5 rounded-md text-sm font-semibold bg-brand-navy text-white hover:bg-brand-navyLight transition-colors" data-id="element-192">
              Book Consultation
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-193">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-slate-900" data-id="element-194">
              {mobileMenuOpen ? <X size={24} data-id="element-195" /> : <Menu size={24} data-id="element-196" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden bg-white shadow-lg absolute top-full left-0 w-full" data-id="element-197">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-198">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50 hover:text-brand-green rounded-md" data-id="element-199">
                {link.name}
              </a>)}
            <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center mt-4 px-5 py-3 rounded-md text-base font-semibold bg-brand-green text-white hover:bg-brand-greenHover" data-id="element-200">
              Book Consultation
            </a>
          </div>
        </div>}
    </nav>;
}